<!--
  - SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
  - SPDX-License-Identifier: AGPL-3.0-or-later
-->

<template>
	<li class="app-navigation-loading-placeholder-entry">
		<div class="icon icon-loading" />
	</li>
</template>
